import step1Proposition1Active from './step1/chien-companie-active.svg';
import step1Proposition1 from './step1/chien-companie.svg';
import step1Proposition3Active from './step1/chien-garde-active.svg';
import step1Proposition3 from './step1/chien-garde.svg';
import step1Proposition2Active from './step1/chien-sport-active.svg';
import step1Proposition2 from './step1/chien-sport.svg';
import step11Proposition3Active from './step11/grand-chien-active.svg';
import step11Proposition3 from './step11/grand-chien.svg';
import step11Proposition2Active from './step11/moyen-chien-active.svg';
import step11Proposition2 from './step11/moyen-chien.svg';
import step11Proposition1Active from './step11/petit-chien-active.svg';
import step11Proposition1 from './step11/petit-chien.svg';
import step12Proposition3Active from './step12/beaucoup-entretiens-active.svg';
import step12Proposition3 from './step12/beaucoup-entretiens.svg';
import step12Proposition2Active from './step12/moyen-entretiens-active.svg';
import step12Proposition2 from './step12/moyen-entretiens.svg';
import step12Proposition1Active from './step12/peu-entretiens-active.svg';
import step12Proposition1 from './step12/peu-entretiens.svg';
import step2Proposition2Active from './step2/appartement-active.svg';
import step2Proposition2 from './step2/appartement.svg';
import step2Proposition1Active from './step2/maison-active.svg';
import step2Proposition1 from './step2/maison.svg';
import step3Proposition4Active from './step3/grand-jardin-active.svg';
import step3Proposition4 from './step3/grand-jardin.svg';
import step3Proposition3Active from './step3/medium-jardin-active.svg';
import step3Proposition3 from './step3/medium-jardin.svg';
import step3Proposition1Active from './step3/no-jardin-active.svg';
import step3Proposition1 from './step3/no-jardin.svg';
import step3Proposition2Active from './step3/petit-jardin-active.svg';
import step3Proposition2 from './step3/petit-jardin.svg';
import step4Proposition2Active from './step4/enfant-8-active.svg';
import step4Proposition3Active from './step4/enfant-8-plus-active.svg';
import step4Proposition3 from './step4/enfant-8-plus.svg';
import step4Proposition2 from './step4/enfant-8.svg';
import step4Proposition1Active from './step4/no-enfants-active.svg';
import step4Proposition1 from './step4/no-enfants.svg';
import step7Proposition1Active from './step7/cal-1x-active.svg';
import step7Proposition1 from './step7/cal-1x.svg';
import step7Proposition2Active from './step7/cal-2x-active.svg';
import step7Proposition2 from './step7/cal-2x.svg';
import step7Proposition3Active from './step7/cal-3x-active.svg';
import step7Proposition3 from './step7/cal-3x.svg';
import step8Proposition3Active from './step8/sablier-grand-active.svg';
import step8Proposition3 from './step8/sablier-grand.svg';
import step8Proposition2Active from './step8/sablier-moyen-active.svg';
import step8Proposition2 from './step8/sablier-moyen.svg';
import step8Proposition1Active from './step8/sablier-petit-active.svg';
import step8Proposition1 from './step8/sablier-petit.svg';

export const assets = {
  // step 1
  step1Proposition1,
  step1Proposition1Active,
  step1Proposition2,
  step1Proposition2Active,
  step1Proposition3,
  step1Proposition3Active,

  // step 2
  step2Proposition1,
  step2Proposition2,
  step2Proposition1Active,
  step2Proposition2Active,

  // step3
  step3Proposition1,
  step3Proposition2,
  step3Proposition3,
  step3Proposition4,
  step3Proposition1Active,
  step3Proposition2Active,
  step3Proposition3Active,
  step3Proposition4Active,

  // step4
  step4Proposition1,
  step4Proposition2,
  step4Proposition3,
  step4Proposition1Active,
  step4Proposition2Active,
  step4Proposition3Active,

  // step7
  step7Proposition1,
  step7Proposition2,
  step7Proposition3,
  step7Proposition1Active,
  step7Proposition2Active,
  step7Proposition3Active,

  // step8
  step8Proposition1,
  step8Proposition2,
  step8Proposition3,
  step8Proposition1Active,
  step8Proposition2Active,
  step8Proposition3Active,

  // step11
  step11Proposition1,
  step11Proposition2,
  step11Proposition3,
  step11Proposition1Active,
  step11Proposition2Active,
  step11Proposition3Active,

  // step12
  step12Proposition1,
  step12Proposition2,
  step12Proposition3,
  step12Proposition1Active,
  step12Proposition2Active,
  step12Proposition3Active,
};
